<template>
  <div>
    <section v-if="modalVisible">
      <deal-form
        :deal-id="dealId"
        :is-read-only="isReadOnly"
        :modal-visible="modalVisible"
        @close="closeModal"
        @close-and-refresh="closeAndRefresh"
        @save-event="saveEvent"
        @create-new="closeAndOpenModalCreate"
        :dealTypeId="3"
        :marketId="marketId"
        :defaultTradeDate="defaultTradeDate"
      />
    </section>

    <section v-show="!modalVisible">
      <page-toolbar>
        <kendo-datepicker
          :value="asOfDate"
          :format="'yyyy-MM-dd'"
          style="width:120px"
          @change="asofDatePickerChanged"
        ></kendo-datepicker>
        <kendo-button
          v-if="!(isMaster || isReadOnly)"
          icon="add"
          title="Create Future"
          @click="openModalCreate"
        >
        </kendo-button>
      </page-toolbar>

      <kendo-grid
        height="calc(100vh - 170px)"
        ref="futureGrid"
        :editable="!isReadOnly && 'inline'"
        :dataSource="dataSource"
        :columns="columns"
        :pageable="true"
        :filterable="true"
        :sortable="true"
        :navigatable="true"
        :autoBind="true"
      ></kendo-grid>
    </section>
  </div>
</template>
<script>
import $ from '@/helpers/jquery-bridge'
import DealForm from '../Deal/DealForm'
import {mapGetters} from 'vuex'
import {enableExportExcel} from '@/helpers/export-helper'
import {getDataItem} from '@/helpers/kendo-helpers'
import PageToolbar from '@/components/PageToolbar'
import categoryColumns from '@/mixins/categoryColumns'
import {checkboxColumn} from '@/helpers/kendo-editors'
import security from '@/mixins/security'

export default {
  name: 'Future',
  mixins: [security, categoryColumns],
  components: {
    DealForm,
    PageToolbar,
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.dealLinkClick)
  },
  mounted() {
    document.body.addEventListener('click', this.dealLinkClick, false)
    let grid = this.$refs.futureGrid.kendoWidget()
    enableExportExcel(grid, '/api/list/future/exportToExcel', $('.page_toolbar-item'))
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({marketId: 'app/marketId'}),
    isMaster() {
      return this.clientId == 0
    },
    grid() {
      return this.$refs.futureGrid
    },
    columns() {
      return [
        {
          field: 'dealId',
          title: 'Group Id',
          width: 100,
          attributes: {style: 'text-align: left;'},
          locked: true,
        },
        {
          field: 'dealCode',
          title: 'Trade Id',
          width: 150,
          template: kendo.template('<a href="javascript:;" class="dealCodeLink">#=dealCode#</a>'),
          locked: true,
        },
        {
          field: 'clientName',
          title: 'Client',
          width: 200,
          hidden: !this.isMaster,
        },
        {
          field: 'tradeDate',
          title: 'Trade Date',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'divisionName',
          title: 'Division',
          width: 150,
        },
        {
          field: 'contractCode',
          title: 'Contract Code',
          width: 150,
        },
        {
          field: 'leg',
          title: 'Contract Type',
          width: 150,
        },
        {
          field: 'counterparty',
          title: 'Counterparty',
          width: 150,
        },
        {
          field: 'exchange',
          title: 'Exchange',
          width: 150,
        },
        {
          field: 'market',
          title: 'Market',
          width: 150,
        },
        {
          field: 'isBuying',
          title: 'Buy / Sell',
          width: 100,
          template: function(item) {
            return item.isBuying ? 'Buy' : 'Sell'
          },
        },
        {
          field: 'numberContract',
          title: 'Number Contract',
          width: 100,
          format: '{0:N0}',
          attributes: {style: 'text-align: right;'},
        },
        {
          field: 'contractSize',
          title: 'Contract Size',
          width: 100,
          format: '{0:N0}',
          attributes: {style: 'text-align: right;'},
        },
        {
          field: 'quantity',
          title: 'Quantity',
          width: 100,
          format: '{0:N0}',
          attributes: {style: 'text-align: right;'},
          //editable: dataItem => dataItem.canEdit,
        },
        {
          field: 'underlying',
          title: 'Underlying',
          width: 132,
        },
        {
          field: 'unit',
          title: 'Unit',
          width: 150,
        },
        {
          field: 'price',
          title: 'Price',
          width: 150,
          format: '{0:N5}',
          attributes: {style: 'text-align: right;'},
          //editable: dataItem => dataItem.canEdit,
        },
        {
          field: 'contractMonth',
          title: 'Contract Month',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM}',
        },
        {
          field: 'lastDeliveryDate',
          title: 'Last Delivery Date',
          width: 120,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd}',
        },
        {
          field: 'year',
          title: 'Hedge Year',
          width: 120,
          attributes: {style: 'text-align: right;'},
        },
        {
          field: 'month',
          title: 'Hedge Month',
          width: 120,
          attributes: {style: 'text-align: right;'},
        },
        {
          field: 'amountCcy',
          title: 'Amount Ccy',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:n}',
        },
        {
          field: 'ccy',
          title: 'Ccy',
          width: 100,
        },
        {
          field: 'statusName',
          title: 'Status',
          width: 100,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'referenceRate',
          title: 'Reference Price',
          width: 132,
          format: '{0:N4}',
        },
        {
          field: 'hedgeTypeCode',
          title: 'Hedge Type',
          width: 90,
        },
        {
          field: 'commission',
          title: 'Commission',
          width: 121,
          format: '{0:N2}',
        },
        {
          field: 'gainLoss',
          title: 'Gain/Loss',
          width: 132,
          format: '{0:N2}',
        },
        checkboxColumn('isExercised', {title: 'Exerc.', width: 80}, true),
        {
          field: 'otherBarrier2',
          title: 'Other Barrier',
          width: 100,
          attributes: {style: 'text-align: right;'},
          template: function(dataItem) {
            if (dataItem.otherBarrier2 == null) return ''
            return '<span>' + kendo.toString(Math.abs(dataItem.otherBarrier2), 'n6') + '</span>'
          },
        },
        {
          field: 'optionTypeName',
          title: 'Opt. Type',
          width: 110,
        },
        {
          field: 'settlementMethodName',
          title: 'Settlement Method',
          width: 110,
        },
        {
          field: 'reference',
          title: 'Ref.',
          width: 142,
        },
        {
          field: 'lastModified',
          title: 'Last Modified',
          width: 140,
          attributes: {style: 'text-align: right;'},
          format: '{0:yyyy-MM-dd HH:mm}',
        },
        {
          field: 'lastUser',
          title: 'Last User',
          width: 190,
          attributes: {style: 'text-align: left;'},
        },
        {
          field: 'responsible',
          title: 'Responsible',
          width: 232,
          attributes: {style: 'text-align: left;'},
          hidden: !this.isMaster,
        },
        {
          field: 'manager',
          title: 'Manager',
          width: 232,
          attributes: {style: 'text-align: left;'},
          hidden: !this.isMaster,
        },
        ...this.categoryColumns,
      ]
    },
    editable() {
      return !(this.role === 'Guest' || this.role === 'Standard')
    },
    defaultTradeDate() {
      const today = new Date(this.asOfDate)
      today.setHours(0, 0, 0, 0)
      return today.toISOString().slice(0, 10)
    },
  },
  methods: {
    dealLinkClick({target}) {
      if (!/dealCodeLink/.test(target.className)) return
      const dataItem = getDataItem(target)
      this.modalVisible = true
      this.dealId = dataItem.dealId
    },
    openModalUpdate: function(e) {
      e.preventDefault()

      let grid = this.$refs.futureGrid.kendoWidget()
      var dataItem = grid.dataItem($(e.currentTarget).closest('tr'))
      this.modalVisible = true
      this.dealId = dataItem.dealId
    },
    closeAndOpenModalCreate() {
      this.closeModal()

      setTimeout(() => {
        this.openModalCreate()
      }, 500)
    },
    openModalCreate() {
      this.modalVisible = true
      this.dealId = 0
    },
    closeModal() {
      this.dealId = null
      this.modalVisible = false
    },
    gridRefresh() {
      let grid = this.$refs.futureGrid.kendoWidget()
      grid.dataSource.read()
    },
    saveEvent(dealId) {
      this.dealId = dealId
    },
    closeAndRefresh() {
      this.closeModal()
      this.refreshCategoryColumns().then(() => {
        this.gridRefresh()
      })
    },
    asofDatePickerChanged(e) {
      this.asOfDate = e.sender.value()
      this.gridRefresh()
    },
  },
  data() {
    return {
      dealId: null,
      modalVisible: false,
      checkedItems: [],
      asOfDate: new Date(),
      dataSource: {
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 20,
        transport: {
          read: {
            type: 'GET',
            url: '/api/list/future',
            data: () => ({
              marketId: this.marketId,
              clientId: this.clientId,
              asOfDate: kendo.toString(this.asOfDate, 'yyyy-MM-dd'),
            }),
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/list/future',
            data: () => ({
              marketId: this.marketId,
              clientId: this.clientId,
            }),
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/list/future',
            data: () => ({
              marketId: this.marketId,
              clientId: this.clientId,
            }),
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/list/future',
            data: () => ({
              marketId: this.marketId,
              clientId: this.clientId,
            }),
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'futureId',
            fields: {
              dealId: {type: 'number', editable: false},
              dealCode: {type: 'string', field: 'dealCode', editable: false},
              divisionName: {type: 'string', editable: false},
              statusName: {type: 'string', editable: false},
              isBuying: {type: 'boolean'},
              quantity: {type: 'number'},
              clientName: {type: 'string', field: 'clientName', editable: false},
              responsible: {type: 'string', editable: false},
              manager: {type: 'string', editable: false},
              lastDeliveryDate: {type: 'date', editable: false},
              tradeDate: {type: 'date', editable: false},
              contractMonth: {type: 'date', editable: false},
              lastModified: {type: 'date', editable: false},
              hedgeTypeCode: {type: 'string'},
              commission: {type: 'number'},
              gainLoss: {type: 'number'},
              isExercised: {type: 'boolean', defaultValue: false},
              otherBarrier2: {type: 'number'},
              optionTypeName: {type: 'string'},
              settlementMethodName: {type: 'string', defaultValue: 'Physical'},
              reference: {type: 'string'},
              referenceRate: {type: 'number'},
              canEdit: {type: 'boolean'},
            },
          },
        },
      },
    }
  },
}
</script>
